let GA_MEASUREMENT_ID = '';

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export type AnalyticsEventParams = Record<string, string | number | boolean | null | undefined>;

export const initGA = (measurementId: string) => {
  if (!measurementId) return;
  if (GA_MEASUREMENT_ID === measurementId && typeof window !== 'undefined' && window.gtag) return;
  GA_MEASUREMENT_ID = measurementId;
  if (typeof window === 'undefined') return;
  if (!document.getElementById('ga4-gtag')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.id = 'ga4-gtag';
    document.head.appendChild(script);
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    (window.dataLayer = window.dataLayer || []).push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { anonymize_ip: true });
};

export const trackPageView = () => {
  if (typeof window === 'undefined' || !window.gtag) return;
  const page_title = document.title;
  const page_location = window.location.href;
  const page_path = window.location.pathname + window.location.search;
  window.gtag('event', 'page_view', { page_title, page_location, page_path });
};

export const trackEvent = (eventName: string, eventParams?: AnalyticsEventParams) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', eventName, eventParams || {});
};
